import { useEffect, useState } from 'react';
import { PropsWithPopup } from 'scbk-services';
import { LoginInfo, useSession } from 'scbk-shared-module/modules/Session';
import { BulletList, BulletListItem, DialogWrapper } from 'scbk-ui-web';

interface Props extends PropsWithPopup {
  onComplete: () => void;
}

const UserInfo: React.FC<Props> = ({ isOpen, setOpen, onComplete }) => {
  const { getLoginInfo } = useSession();
  const [ipProtectCode, setIpProtectCode] = useState('');
  const [connectedCountryCode, setConnectedCountryCode] = useState('');
  const [flagIsAbroadYn, setFlagIsAbroadYn] = useState('');
  const [pcFixValue, setPcFixValue] = useState('');
  const [otherPcYes, setOtherPcYes] = useState('');
  const [transPwUseYn, setTransPwUseYn] = useState('');

  useEffect(() => {
    // 로그인 정보
    getLoginInfo([
      'ipProtectCode',
      'connectedCountryCode',
      'flagIsAbroadYn',
      'pcFixValue',
      'otherPcYes',
      'transPwUseYn',
    ])
      .then((loginInfo: LoginInfo) => {
        setIpProtectCode(loginInfo?.ipProtectCode);
        setConnectedCountryCode(loginInfo?.connectedCountryCode);
        setFlagIsAbroadYn(loginInfo?.flagIsAbroadYn);
        setPcFixValue(loginInfo?.pcFixValue);
        setOtherPcYes(loginInfo?.otherPcYes);
        setTransPwUseYn(loginInfo?.transPwUseYn);
      })
      .catch((error) => {
        console.log('getLoginInfo error :: ', error);
      });
  }, [isOpen]);

  return (
    <DialogWrapper
      title={'사용자정보'}
      open={isOpen}
      setOpen={setOpen}
      isFull={true}
      footer={[
        {
          type: 'primary',
          title: '확인',
          handler: () => {
            console.log('확인!');
            onComplete?.();
          },
          hasClose: true,
        },
      ]}
      onClose={() => {}}
    >
      <div className="flex flex-col gap-8">
        <div className="flex flex-col gap-3">
          <BulletList type="circle" size="medium">
            <BulletListItem>
              해외IP차단서비스 사용여부({ipProtectCode}) :{' '}
              <b>
                {ipProtectCode === '1'
                  ? '전체코드'
                  : ipProtectCode === '2'
                    ? '특정국가차단'
                    : '미가입'}
              </b>
            </BulletListItem>
            <BulletListItem>
              접속국가코드(국내:107) : <b>{connectedCountryCode}</b>
            </BulletListItem>
            <BulletListItem>
              해외IP접속여부({flagIsAbroadYn}) : <b>{flagIsAbroadYn === 'Y' ? '해외' : '국내'}</b>
            </BulletListItem>
            <BulletListItem>
              단말기지정서비스({pcFixValue}) : <b>{pcFixValue === '2' ? '지정PC' : '미지정PC'}</b>
            </BulletListItem>
            <BulletListItem>
              단말기지정서비스 다른PC 허용여부({otherPcYes}) :
              <b>{otherPcYes === 'Y' ? '허용' : '미허용'}</b>
            </BulletListItem>
            <BulletListItem>
              이체비밀번호 사용여부({transPwUseYn}) :{' '}
              <b>{transPwUseYn === '1' ? '미사용' : '사용'}</b>
            </BulletListItem>
          </BulletList>
        </div>
      </div>
    </DialogWrapper>
  );
};

export default UserInfo;
